import ApiService from '@/common/api.service'

export default {
  getHoliday () {
    return new Promise((resolve, reject) => {
      ApiService.query('/check-list/getHoliday').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
